import { render, staticRenderFns } from "./TheaterSubscriptionPassDetailsContainer.vue?vue&type=template&id=2d704e89&scoped=true"
import script from "./TheaterSubscriptionPassDetailsContainer.vue?vue&type=script&lang=js"
export * from "./TheaterSubscriptionPassDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./TheaterSubscriptionPassDetailsContainer.vue?vue&type=style&index=0&id=2d704e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d704e89",
  null
  
)

export default component.exports